import React from 'react';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Accordion, AccordionTab } from 'primereact/accordion';
import { Button } from 'primereact/button';

import { useOrderServiceReportscontroller } from 'src/controllers/DataReports/ServiceOrder/OrderServiceReport';
import { dateToString } from 'src/utils/dateToString';
import { ModelOfOrderService } from 'src/database';

import '../styles.scss';

interface ServiceCardProps {
  orderService: ModelOfOrderService;
  handleClick: ({ }: any) => void;
}

const FinishOrderServiceCard: React.FC<ServiceCardProps> = ({ orderService, handleClick }) => {
  const { handleOrderServiceReport } = useOrderServiceReportscontroller();

  return (
    <div className="container-row">
      <div className="container">
        <div className="card-header">
          <span>FINALIZADA</span>
        </div>
        <div className="card-body">
          <div className="card-column">
            <div className="card-content">
              <span className="info-title">Veículo</span>
              <span className="info-text">{orderService.DESCRICAO_VEICULO}</span>
            </div>
            <div className="card-content">
              <span className="info-title">Descrição da demanda</span>
              <span className="info-text">{orderService.DESCRICAO_DEMANDA}</span>
            </div>
            <div className="card-content">
              <span className="info-title">Requisitado por</span>
              <span className="info-text">{orderService.NOME_PESSOAORIGEM}</span>
            </div>
            <div className="card-content">
              <span className="info-title">Unidade</span>
              <span className="info-text">{orderService.NOME_ORGAOUNIDADEDESTINO}</span>
            </div>
            <div className="button-container">
              <Button className="button" onClick={() => { handleOrderServiceReport.generateOrderServiceReport(orderService) }}>
                <FontAwesomeIcon icon={faPlus} />
                <span className="p-ml-2"> Gerar ordem de serviço</span>
              </Button>
            </div>
          </div>

          <div className="card-column">
            <div className="card-content">
              <span className="info-title">Placa</span>
              <span className="info-text">{orderService.PLACA_VEICULO}</span>
            </div>
            <div className="card-content">
              <span className="info-title">Data criada / Data finalizada</span>
              <span className="info-text">{`${dateToString(orderService.DATA_DEMANDA, 'br')} / ${dateToString(orderService.DATAEFETIVADA, 'br')}`}</span>
            </div>
            <div className="card-content">
              <span className="info-title">Órgão</span>
              <span className="info-text">{orderService.NOME_ORGAO}</span>
            </div>
            <div className="card-content">
              <span className="info-title">Manutenção</span>
              <span className="info-text">{orderService.DESCRICAO_TIPOORDEMSERVICO}</span>
            </div>
          </div>

        </div>
        <div className="card-footer">
          <Accordion className="footer-accordion">
            <AccordionTab headerClassName="footer-accordion" header="Produtos utilizados / Serviços realizados ">
              <div className="footer-column">
                <h5>Produtos</h5>
                {orderService.PRODUTOS.map((product: any) => {
                  return (
                    <div className="footer-content" key={product.ID} >
                      <div className="footer-column">
                        <span className="info-title">Produto</span>
                        <span className="info-text" >{product.DESCRICAO_PRODUTO}</span>
                      </div>
                      <div className="footer-column">
                        <span className="info-title">Quantidade</span>
                        <span className="info-text" >{product.QUANTIDADE_PRODUTO}</span>
                      </div>
                      <div className="footer-column">
                        <span className="info-title">Valor Unitário</span>
                        <span className="info-text" >R$ {Number((product.VALOR_PRODUTO).toFixed(2))}</span>
                      </div>
                      <div className="footer-column">
                        <span className="info-title">Valor total</span>
                        <span className="info-text" >R$ {Number((product.VALOR_PRODUTO * product.QUANTIDADE_PRODUTO).toFixed(2))}</span>
                      </div>
                    </div>
                  )
                })}
              </div>

              <div className="footer-column">
                <h5>Serviços</h5>
                {orderService.SERVICOS.map((service: any) => {
                  return (
                    <div className="footer-content" key={service.ID} >
                      <div className="footer-column">
                        <span className="info-title">Serviço</span>
                        <span className="info-text" >{service.DESCRICAO_SERVICO}</span>
                      </div>
                      <div className="footer-column">
                        <span className="info-title">Quantidade</span>
                        <span className="info-text" >{service.QUANTIDADE_SERVICO}</span>
                      </div>
                      <div className="footer-column">
                        <span className="info-title">Valor Unitário</span>
                        <span className="info-text" >R$ {Number((service.VALOR_SERVICO).toFixed(2))}</span>
                      </div>
                      <div className="footer-column">
                        <span className="info-title">Valor total</span>
                        <span className="info-text" >R$ {Number((service.VALOR_SERVICO * service.QUANTIDADE_SERVICO).toFixed(2))}</span>
                      </div>
                    </div>
                  )
                })}
              </div>
            </AccordionTab>
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default FinishOrderServiceCard;